// @ts-check

import { isImage, isPdf, isXlsx } from '@/helpers/files'
import { computed, unref } from 'vue'

/**
 * @param {import('vue').MaybeRef<Pick<AttachmentResource, 'mime_type'>>} attachment
 */
export const useAttachment = (attachment) => {
  return {
    isImage: computed(() => isImage(unref(attachment))),
    isPdf: computed(() => isPdf(unref(attachment))),
    isXlsx: computed(() => isXlsx(unref(attachment)))
  }
}
